import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from '../../../../../components/card/NewCard'
import Select from '../../../../../components/forms/Select'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import useSandreList from '../../../../../utils/customHook/useSandreList'
import NumberField from '../../../../../components/forms/NumberField'

const EcoFriendlyFeaturesDescription = ({ taxon, onChange, disabled }) => {
    const taxonsSpeciesStatus = useSandreList('TAXONS.SPECIES.STATUS')
    const taxonsType = useSandreList('TAXONS.TYPE')
    return (
        <Card>
            <CardTitle title={i18n.description} />
            <CardContent>
                <Grid container spacing={1}>
                    <Grid size={3}>
                        <Input
                            title={ i18n.basionym }
                            value={ taxon.basionym }
                            onChange={ v => onChange({ basionym: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Input
                            title={ i18n.synonyms }
                            value={ taxon.synonyms }
                            onChange={ v => onChange({ synonyms: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            label={ i18n.speciesStatus }
                            value={ taxon.speciesStatus }
                            options={ taxonsSpeciesStatus }
                            onChange={ v => onChange({ speciesStatus: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            label={ i18n.speciesType }
                            value={ taxon.speciesType }
                            options={ taxonsType }
                            onChange={ v => onChange({ speciesType: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Input
                            title={ i18n.notes }
                            value={ taxon.notes }
                            onChange={ v => onChange({ notes: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.ibd }
                            value={ taxon.noteibd }
                            onChange={ v => onChange({ noteibd: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.ips }
                            value={ taxon.noteips }
                            onChange={ v => onChange({ noteips: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

EcoFriendlyFeaturesDescription.propTypes = {
    taxon: PropTypes.object,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
}

export default EcoFriendlyFeaturesDescription